import React from "react";

// import Pagination from "../../components/Pagination";
import CashierApi from "../../utility/CashierApi";
import { useQuery } from "@tanstack/react-query";
import loader from "../../assets/loader.webp";
import CategoryProductCard from "./CategoryProductCard";

function CategoryProducts({ categoryId }) {
  const { getDataById } = CashierApi();
  //   const [totalPage, setTotalPage] = useState(1);

  const { data, isLoading } = useQuery({
    queryKey: ["products", categoryId],
    queryFn: () => getDataById("categories/products/", categoryId),
    keepPreviousData: true,
    enabled: !!categoryId,
    retry: 1,
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  let items = data?.data?.data;
  if (isLoading) {
    return (
      <div className="h-full w-full flex justify-center items-center">
        <img src={loader} alt="loading..." className="w-12" />
      </div>
    );
  }

  return (
    <div className="overflow-y-auto h-[calc(100vh-150px)] pb-20 px-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
      {items.length === 0 ? (
        <div>
          <h4 className="text-center mt-12 text-2xl">
            No Category Products Available
          </h4>
        </div>
      ) : (
        <div className="grid grid-cols-4 w-full px-12 gap-4">
          {items?.map((item) => (
            <CategoryProductCard key={item?.id} item={item} />
          ))}
        </div>
      )}

      {/* <Pagination
        onPageChange={handlePageChange}
        totalPage={totalPage}
        currentPage={currentPage}
        setIsNextLoading={setIsNextLoading}
        setIsPrevLoading={setIsPrevLoading}
        isPrevLoading={isPrevLoading}
        isNextLoading={isNextLoading}
      /> */}
    </div>
  );
}

export default React.memo(CategoryProducts);
